import { ClipLoader } from 'react-spinners'
export default ClipLoader

export type SpinnerProps = typeof ClipLoader
